<template>
  <div class="profile">
    <div class="container">
      <div class="profile__info">
        <router-link :to="{ name:'user.profile', params: {slug: user.slug} }">
          <picture
            class="profile__avatar"
            :style="{ backgroundImage: `url(${user.avatar})`}"
          ></picture>
        </router-link>

        <div class="profile__text">
          <div class="profile__user">
            <h5 class="profile__user__name">{{ user.name }}</h5>
            <UserProfileBio :user="user" />
          </div>

          <UserProfileStatsList :user="user"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserProfileStatsList from './UserProfileStatsList'
import UserProfileBio from '@/components/user/profile/UserProfileBio'

export default {
  components: {
    UserProfileStatsList,
    UserProfileBio,
  },
  
  props: {
    user: { type: Object, required: true }
  },
}
</script>

<style scoped lang="scss">
  .profile {
    padding: 2.5rem 0;

    &__info {
      display: flex;
      align-items: flex-start;
      gap: 20px;
    }

    &__avatar {
      flex: 0 0 auto;
      display: block;
      width: 6rem;
      height: 6rem;
      background-size: cover;
      background-position: center;
      border-radius: 100%;
    }

    &__user {
      margin-bottom: 8px;

      &__name {

      }
  
      &__quote {
        font-size: 1rem;
      }
    }

    @media (max-width: 768px) {
      &__info { flex-direction: column; align-items: center }

      &__user { text-align: center }
    }
  }
</style>